import { FC } from 'react';

const PasswordChangedConfirmationPage: FC = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-4 max-w-full mx-auto w-[1280px] px-4 py-10">
      <h2 className="font-bold text-2xl">Password changed</h2>
      <p>Your password has been successfully changed. You can now log in with your new password.</p>
    </div>
  );
};

export default PasswordChangedConfirmationPage;
